import React from 'react';
import PropTypes from 'prop-types';
const maxBy = require('lodash/maxBy');
import { Row } from 'react-bootstrap';

const Strings = require('../../../../app/shared/Strings');
const StringUtil = require('../../../../app/shared/StringUtil');
import DonutChart from '../chart/DonutChart';
import BarChart from '../chart/BarChart';
import AccessibleIcon from '../common/AccessibleIcon';
import StatTile from '../tiles/StatTile';

const propTypes = {
    className: PropTypes.string,
    overviewAnalytics: PropTypes.object
};

const defaultProps = {
    className: '',
    overviewAnalytics: null
};

function AssignmentAnalyticsOverview({ className, overviewAnalytics }) {
    if (!overviewAnalytics) {
        return null;
    }

    function renderAttemptsStartedChart(id) {
        return (
            <DonutChart
                id={id}
                height={120}
                width={120}
                labelShow={false}
                columns={[['Started', overviewAnalytics.attemptsStarted], ['Not Started', overviewAnalytics.attemptCount - overviewAnalytics.attemptsStarted]]}
                colors={{ 'Started': "#1F77B4", 'Not Started': "#dddddd" }}
                summaryStat={overviewAnalytics.attemptCount > 0 ? `${Math.round(overviewAnalytics.attemptsStarted * 100 / overviewAnalytics.attemptCount)}%` : '0%'}
            />
        );
    }

    function renderAttemptsCompleteChart(id) {
        return (
            <DonutChart
                id={id}
                height={120}
                width={120}
                labelShow={false}
                columns={[['Completed', overviewAnalytics.attemptsCompleted], ['Not Completed', overviewAnalytics.attemptCount - overviewAnalytics.attemptsCompleted]]}
                colors={{ 'Completed': "#1F77B4", 'Not Completed': "#dddddd" }}
                summaryStat={overviewAnalytics.attemptCount > 0 ? `${Math.round(overviewAnalytics.attemptsCompleted * 100 / overviewAnalytics.attemptCount)}%` : '0%'}
            />
        );
    }

    function renderTimePlayedDistrChart(id, width, legendPosition) {
        return (
            <BarChart
                id={id}
                height={150}
                width={width}
                legendShow={true}
                legendPosition={legendPosition}
                xAxisType="category"
                removeXTick
                yTickValues={[0, maxBy(overviewAnalytics.timePlayedDistrGraphData, (colData) => { return colData[1]})[1]]}
                columns={overviewAnalytics.timePlayedDistrGraphData}
            />
        );
    }

    return (
        <div className={className}>
            <table className="ml-table dark centered-cells large-cells margin-bottom-md d-none d-lg-table">
                <thead className="table-header mzl-border-bottom">
                    <tr>
                        <th>
                            {Strings['en'].analytics.overview.channel_assn_analytics_overview.ASSIGNMENTS}
                        </th>
                        <th>
                            {Strings['en'].analytics.overview.channel_assn_analytics_overview.ATTEMPTS}
                        </th>
                        <th>
                            {Strings['en'].analytics.overview.channel_assn_analytics_overview.ATT_STARTED}
                        </th>
                        <th>
                            {Strings['en'].analytics.overview.channel_assn_analytics_overview.ATT_COMPLETED}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            {StringUtil.numberToLocaleString(overviewAnalytics.assignmentCount)}
                        </td>
                        <td>
                            {StringUtil.numberToLocaleString(overviewAnalytics.attemptCount)}
                        </td>
                        <td>
                            {renderAttemptsStartedChart("chart-started-percent-lg")}
                        </td>
                        <td>
                            {renderAttemptsCompleteChart("chart-completed-percent-lg")}
                        </td>
                    </tr>
                </tbody>
            </table>
            <Row className="d-block d-lg-none">
                <StatTile
                className="font-size-xl text-centered mzl-border-bottom col-12 col-sm-6"
                term={Strings['en'].analytics.overview.channel_assn_analytics_overview.ASSIGNMENTS}
                >
                    {StringUtil.numberToLocaleString(overviewAnalytics.assignmentCount)}
                </StatTile>
                <StatTile
                className="font-size-xl text-centered mzl-border-bottom col-12 col-sm-6"
                term={Strings['en'].analytics.overview.channel_assn_analytics_overview.ATTEMPTS}
                >
                    {StringUtil.numberToLocaleString(overviewAnalytics.attemptCount)}
                </StatTile>
                <StatTile
                className="font-size-xl text-centered mzl-border-bottom col-12 col-sm-6"
                term={Strings['en'].analytics.overview.channel_assn_analytics_overview.ATT_STARTED}
                >
                    {renderAttemptsStartedChart("chart-started-percent-sm")}
                </StatTile>
                <StatTile
                className="font-size-xl text-centered mzl-border-bottom col-12 col-sm-6"
                term={Strings['en'].analytics.overview.channel_assn_analytics_overview.ATT_COMPLETED}
                >
                    {renderAttemptsCompleteChart("chart-completed-percent-sm")}
                </StatTile>
            </Row>
            <table className="ml-table dark centered-cells large-cells pad-cells-md d-none d-lg-table">
                <thead className="table-header mzl-border-bottom">
                    <tr>
                        <th>
                            {Strings['en'].analytics.overview.channel_assn_analytics_overview.TOTAL_TIME_PLAYED}
                        </th>
                        <th>
                            {Strings['en'].analytics.overview.channel_assn_analytics_overview.AVG_TIME_PLAYED}
                        </th>
                        <th>
                            {Strings['en'].analytics.overview.channel_assn_analytics_overview.TP_DIST}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            {StringUtil.getTimeStringForMs(overviewAnalytics.totalTimePlayed)}
                        </td>
                        <td>
                            {StringUtil.getTimeStringForMs(overviewAnalytics.avgTimePlayed)}
                        </td>
                        <td>
                            {renderTimePlayedDistrChart("chart-time-played-distr-lg", 300, "right")}
                        </td>
                    </tr>
                </tbody>
            </table>
            <Row className="d-block d-lg-none">
                <StatTile
                className="font-size-xl text-centered mzl-border-bottom col-12 col-sm-6"
                term={Strings['en'].analytics.overview.channel_assn_analytics_overview.TOTAL_TIME_PLAYED}
                >
                    {StringUtil.getTimeStringForMs(overviewAnalytics.totalTimePlayed)}
                </StatTile>
                <StatTile
                className="font-size-xl text-centered mzl-border-bottom col-12 col-sm-6"
                term={Strings['en'].analytics.overview.channel_assn_analytics_overview.AVG_TIME_PLAYED}
                >
                    {StringUtil.getTimeStringForMs(overviewAnalytics.avgTimePlayed)}
                </StatTile>
                <StatTile
                className="font-size-xl text-centered mzl-border-bottom col-12 col-sm-12"
                term={Strings['en'].analytics.overview.channel_assn_analytics_overview.TP_DIST}
                >
                    {renderTimePlayedDistrChart("chart-time-played-distr-sm", 200, "bottom")}
                </StatTile>
            </Row>
        </div>
    );
}

AssignmentAnalyticsOverview.propTypes = propTypes;
AssignmentAnalyticsOverview.defaultProps = defaultProps;

export default AssignmentAnalyticsOverview;
